import { ChartColumn } from 'lucide-react';
import { LinkBase, useTranslate } from 'ra-core';
import { useParams } from 'react-router-dom';
import { buttonVariants } from '../../components/ui/button';
import { MoonstarEdit } from '../Moonstar/MoonstarEdit';
import { MoonstarEditForm } from '../Moonstar/MoonstarEditForm';
import { SimpleStack } from '../Moonstar/SimpleStack';
import { ResourcesValue } from '../resources';
import { BadgeInputs } from './BadgeInputs';

export const BadgesEdit = () => (
  <MoonstarEdit redirect="list" hideDelete actions={<BadgesEditActions />}>
    <MoonstarEditForm>
      <SimpleStack>
        <BadgeInputs />
      </SimpleStack>
    </MoonstarEditForm>
  </MoonstarEdit>
);

const BadgesEditActions = () => {
  const { id } = useParams();
  const translate = useTranslate();

  return (
    <LinkBase
      to={`/${ResourcesValue.BADGE_AWARDS}/analytics/${id}`}
      className={buttonVariants({ variant: 'outline' })}
    >
      <ChartColumn />
      {translate('moonstar.analytics.name')}
    </LinkBase>
  );
};
